import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import storage from '../../utils/storage';
import './Header.css';

const Header = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 检查当前用户
    const user = storage.getCurrentUser();
    setCurrentUser(user);

    // 监听存储变化
    const handleStorageChange = () => {
      const updatedUser = storage.getCurrentUser();
      setCurrentUser(updatedUser);
    };

    window.addEventListener('storage', handleStorageChange);
    
    // 自定义事件监听f
    window.addEventListener('userChange', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userChange', handleStorageChange);
    };
  }, []);

  const handleLogout = () => {
    storage.clearCurrentUser();
    setCurrentUser(null);
    setIsUserMenuOpen(false);
    // 触发自定义事件
    window.dispatchEvent(new Event('userChange'));
    navigate('/');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo">
          BBB Blog
        </Link>

        <nav className="header-nav">
          <ul className="header-nav-links">
            <li>
              <Link to="/" className={`header-nav-link ${isActive('/')}`}>
                首页
              </Link>
            </li>
            <li>
              <Link to="/archive" className={`header-nav-link ${isActive('/archive')}`}>
                归档
              </Link>
            </li>
            <li>
              <Link to="/about" className={`header-nav-link ${isActive('/about')}`}>
                关于
              </Link>
            </li>
            {currentUser && (
              <li>
                <Link to="/write" className={`header-nav-link ${isActive('/write')}`}>
                  写文章
                </Link>
              </li>
            )}
          </ul>

          <div className="header-user">
            {currentUser ? (
              <div className="header-user-menu">
                <img
                  src={currentUser.avatar}
                  alt={currentUser.username}
                  className="header-avatar"
                  onClick={toggleUserMenu}
                />
                {isUserMenuOpen && (
                  <div className="header-dropdown">
                    <Link to="/about" className="header-dropdown-item">
                      个人中心
                    </Link>
                    <button onClick={handleLogout} className="header-dropdown-item">
                      退出登录
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/auth" className="header-nav-link">
                登录/注册
              </Link>
            )}
          </div>
        </nav>

        <button className="header-mobile-menu" onClick={toggleMenu}>
          ☰
        </button>
      </div>

      {/* 移动端菜单 */}
      {isMenuOpen && (
        <div className="header-mobile-dropdown">
          <Link to="/" className={`header-mobile-link ${isActive('/')}`} onClick={toggleMenu}>
            首页
          </Link>
          <Link to="/archive" className={`header-mobile-link ${isActive('/archive')}`} onClick={toggleMenu}>
            归档
          </Link>
          <Link to="/about" className={`header-mobile-link ${isActive('/about')}`} onClick={toggleMenu}>
            关于
          </Link>
          {currentUser && (
            <Link to="/write" className={`header-mobile-link ${isActive('/write')}`} onClick={toggleMenu}>
              写文章
            </Link>
          )}
          {!currentUser && (
            <Link to="/auth" className="header-mobile-link" onClick={toggleMenu}>
              登录/注册
            </Link>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;